import { render } from "./PageUnderConstruction.vue?vue&type=template&id=5584ee1b"
import script from "./PageUnderConstruction.vue?vue&type=script&lang=js"
export * from "./PageUnderConstruction.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__